import {connect} from 'react-redux';
import React from 'react';

import EventAttachment from '../EventAttachments/EventAttachment';
import WaitWhileBusy from '../../WaitWhileBusy';

const EventImageAttachmentConnectedToState = connect((state, props) => {
    let event = state.events[props.eventId].event,
        question = state.events[props.eventId].questions.indexed[props.questionId];

    return {
        event,
        attachment: _(question.attachments).find(attachment => attachment.id == props.attachmentId),
    };
})(EventAttachment);

export default props => (
    <WaitWhileBusy>
        <EventImageAttachmentConnectedToState {...props.match.params} />
    </WaitWhileBusy>
);
